import {getElements} from "./utils/getElement";

const initNestedMenu = () => {
    const nestedMenu = getElements('.js-nested-menu');

    const openSubmenu = (menuItem) => {
        const submenu = menuItem.querySelector('.js-nested-submenu');
        submenu.classList.add('is-open');
    };

    const closeSubmenu = (submenu) => {
        submenu.classList.remove('is-open');
    };

    nestedMenu.forEach(menuItem => {
        const submenu = menuItem.querySelector('.js-nested-submenu');
        const subMenuCloseBtn = submenu.querySelector('.js-nested-menu-close');

        if (subMenuCloseBtn) {
            subMenuCloseBtn.addEventListener('click', (e) => {
                e.stopPropagation(); // Prevent event bubbling
                closeSubmenu(submenu);
            });
        }

        menuItem.addEventListener('click', (e) => {
            if (window.matchMedia('(max-width: 992px)').matches) {
                const isDirectClick = menuItem === e.target || menuItem.contains(e.target) && !submenu.contains(e.target);

                if (isDirectClick) {
                    e.preventDefault();
                    openSubmenu(menuItem);
                }
            }
        });
    });
};

export {initNestedMenu};
